      <h1 mat-dialog-title i18n id = "write-in-dialog"
       aria-label="write-in-dialog" 
       i18n-aria-label="Write-in Dialog"     
       >Enter name</h1>        
      <mat-dialog-content id = "write-in-dialog" i18n >
        <input type="text" [(ngModel)]="userInput" (input)="validateInput()" id="write-in-name" name="write-in-name">
        @if(errorMessage){
          <div class="error-message" aria-live="assertive" role="alert">
            <img src="/assets/images/warning.svg" alt="alert" width="30" height="30"> &nbsp; {{ errorMessage }}
          </div>
        }

    </mat-dialog-content>
    <mat-dialog-actions >
      <div class="dialog-button-container">
        <button  [disabled]="inputError"  id="write-in-closed-button" i18n class="button-primary button--small" (click)="closeDialog()">OK</button>
        <button id="write-in-closed-button" i18n class="button-primary button--small" (click)=cancelDialog()>CANCEL</button>
      </div>
    </mat-dialog-actions>


